import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchGetProducts, hasProduct } from "../../../../queries/products";
import { Products } from "../../../../constants/products";

const useProducts = () => {
  const dispatch = useDispatch();
  const params = useParams<{ site: string }>();
  const productsQuery = useQuery(["products", params.site], fetchGetProducts(dispatch));

  const hasCrm = hasProduct(productsQuery, Products.CRM);
  const hasCe = hasProduct(productsQuery, Products.CE);
  const hasCommunications = hasProduct(productsQuery, Products.COMMUNICATIONS);
  const hasPermits = hasProduct(productsQuery, Products.PERMITS);
  const hasSSOMicrosoft = hasProduct(productsQuery, Products.SSO_MICROSOFT);

  return { hasCrm, hasCe, hasCommunications, hasPermits, hasSSOMicrosoft, productsQuery };
};

export default useProducts;
